import { useStoreState } from "ezStore";
import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { CurrencyFragment } from "__generated__/graphql/fragments.generated";

const CurrencySelect = ({ value, onChange, disabled }: Omit<SelectProps<CurrencyFragment, false>, "fetchOptions">) => {

	const session = useStoreState(store => store.session);

	const currencies = session.currencies;
	const contractCurrencies = session.settings?.multiValues.contractCurrencies;

	const onFetchOptions = () => {
		if (contractCurrencies) {
			const pluginCurrencies = contractCurrencies.split(";");
			return [ ...currencies ].sort((a, b) => pluginCurrencies.indexOf(b.isoCode || "") - pluginCurrencies.indexOf(a.isoCode || ""));
		} else {
			return [ ...currencies ];
		}
	};

	return (
		<Select
			fetchOptions={onFetchOptions}
			onChange={onChange}
			getOptionLabel={option => `${option.isoCode} (${option.symbol})`}
			value={value}
			disabled={disabled}
			clearable={false} />
	);
};

export default CurrencySelect;
